module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_10-c7f0036f5a472f379095973e3fd09781.jpg";